import { twMerge } from "tailwind-merge";

import SelectedRemovableItem from "components/partials/selected-removable-items/selected-removable-item/selected-removable-item";
import type { TouchpointAttributes } from "hooks/api/use-touchpoints";

type SelectedRemovableItemsProps = {
  selectedList: TouchpointAttributes[];
  onRemoveSelectedItem?: (itemId: string) => void;
  showStatus?: boolean;
  showBatch?: boolean;
};

const SelectedRemovableItems = ({
  selectedList,
  onRemoveSelectedItem = () => {},
  showStatus = false,
  showBatch = false,
}: SelectedRemovableItemsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <h2>Selected items</h2>
      <div
        className={twMerge(
          "flex flex-col gap-2.5 h-36 overflow-y-auto custom-scroll py-0.5",
          selectedList.length > 3 && "pr-3",
        )}>
        {selectedList?.length ? (
          selectedList.map((item) => {
            return (
              <SelectedRemovableItem
                key={item.id}
                id={item.id}
                name={item.name}
                latestVersion={item.latestVersion}
                type={item.type}
                onRemove={onRemoveSelectedItem}
                showStatus={showStatus}
                showBatch={showBatch}
                touchpointBatchName={showBatch ? item.touchpointBatchName : undefined}
              />
            );
          })
        ) : (
          <span className="text-gray-500">No items selected yet.</span>
        )}
      </div>
    </div>
  );
};

export default SelectedRemovableItems;
